export var UtmCampaign = /*#__PURE__*/function (UtmCampaign) {
  UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
  return UtmCampaign;
}({});